import HeadlineThree from 'ui-component-library/components/00-Primitives/Headlines/HeadlineThree'
import Paragraph from 'content-components/_Primatives/Paragraph'
import style from './style.scss'

type Props = {
  className?: string
  headlineText: string
  commentsLabelText: string
  commentsCount: number
  actionButtons: React.ReactNode
  commentButton: React.ReactNode
}

function Header({
  commentsCount,
  commentsLabelText,
  actionButtons,
  commentButton,
  headlineText,
}: Props) {
  return (
    <header>
      <HeadlineThree>{headlineText}</HeadlineThree>
      <div className={style.topBar}>
        <Paragraph className={style.commentsCount} small>
          {`${commentsCount} ${commentsLabelText}`}
        </Paragraph>
        <div className={style.actionButtons}>{actionButtons}</div>
        {commentButton}
      </div>
    </header>
  )
}

export default Header
